import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';
import { getErrorString } from '../../utils';
import { getQueryString } from '../../utils/filters-util';
import { fetchFollowUpsApi } from '../../api/follow-up-api';
import { setQuickLinks } from 'reducers/quick-links-slice';

const initialState = {
  activeColumns: [],
  followUps: [],
  loading: true,
  aggs: {},
  pending: false,
  pagination: {},
};

export const fetchFollowUpsListing = createAsyncThunk(
  'followups/listing',
  async (updatedParamsObject = {}, { dispatch }) => {
  try {
    const paramsObj = {
      ...updatedParamsObject,
      aggs: 'true',
    };
    const res = await fetchFollowUpsApi({}, getQueryString(paramsObj));
    if (res?.status) {
      dispatch(setQuickLinks(res?.user_filters));
    }
    return res;
  } catch (error) {
    toast.error(getErrorString(error));
  }
  },
);

const FollowUpSlice = createSlice({
  name: 'followup',
  initialState,
  reducers: {
    setFollowUpLoading: (state, action) => {
      state.loading = action?.payload?.loading;
    },
    setFollowUpActiveColumn: (state, action) => {
      state.activeColumns = action?.payload?.activeColumns;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchFollowUpsListing.pending, (state) => {
        state.pending = true;
      })
      .addCase(fetchFollowUpsListing.fulfilled, (state, action) => {
        if (state.loading) {
          state.activeColumns = action?.payload?.active_columns || [];
        }
        state.followUps = action?.payload?.data || [];
        state.aggs = action?.payload?.aggs || {};
        state.loading = false;
        state.pending = false;
        state.pagination = action?.payload?.meta?.pagination || {};
      })
      .addCase(fetchFollowUpsListing.rejected, (state) => {
        state.loading = false;
        state.pending = false;
      });
  },
});

export const { setFollowUpLoading, setFollowUpActiveColumn } = FollowUpSlice.actions;
export default FollowUpSlice.reducer;
